import * as React from "react";
import lowerCase from "lodash/lowerCase";
import { useTranslation } from "react-i18next";
import { Tooltip } from "components/common";
import useEntityCollectionStatus from "collections/hooks/useEntityCollectionStatus";
import { createGRN } from "logic/permissions/GRN";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
const EntityCollectionCell = ({ entityId, entityType }) => {
  const { t } = useTranslation("enterprise_collections");
  const entityGRN = createGRN(entityType, entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entityId);
  const count = (data == null ? void 0 : data.length) || 0;
  if (isFetching || isError) {
    return null;
  }
  if (count === 0) {
    return null;
  }
  const label = /* @__PURE__ */ React.createElement("span", null, t("entity_collection_cell.label", { count, entityType: lowerCase(entityType) }));
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label }, /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId,
      section: "collections",
      count,
      label: t("entity_collection_cell.section_label")
    }
  ));
};
export const getCollectionsCustomColumnRenderer = (entityType) => ({
  collections: {
    renderCell: (_collections, entity) => /* @__PURE__ */ React.createElement(EntityCollectionCell, { entityId: entity.id, entityType }),
    staticWidth: "matchHeader",
    textAlign: "right"
  }
});
export default EntityCollectionCell;
